import { gql } from '@apollo/client';
import { cx } from '@orn/shared-web/utils/cx';
import * as React from 'react';

import { PATHS } from '../../../paths';
import { useNavigateWithDateRange } from '../../../providers/DateRangeProvider';
import EntityAvatar from '../../entity/EntityAvatar';

import type { EntitySearchItemFragment } from './__generated__/EntitySearchItem.gql';

interface IEntitySearchItemProps {
  entity: EntitySearchItemFragment;
  onSelect?: () => void;
  isSelected?: boolean;
}

const EntitySearchItem = ({ entity, onSelect, isSelected = false }: IEntitySearchItemProps) => {
  const navigate = useNavigateWithDateRange();

  const handleClick = React.useCallback(() => {
    onSelect?.();
    switch (entity.__typename) {
      case 'Merchant':
        navigate(PATHS.MERCHANT(entity.id));
        break;
      case 'FinancialAccount':
        navigate(PATHS.ACCOUNT(entity.id));
        break;
      default:
        break;
    }
  }, [entity, navigate, onSelect]);

  return (
    <div
      data-entity-search-item
      className={cx(
        'hover:bg-primary_hover h-13 flex cursor-pointer items-center gap-2 rounded-lg px-2 py-2',
        isSelected && 'ring-brand ring-2 ring-inset'
      )}
      onClick={handleClick}
    >
      <EntityAvatar entity={entity} size="xs" />
      <span className="text-primary truncate text-sm font-medium">{entity.name}</span>
    </div>
  );
};

const EntitySearchItemFragmentGQL = gql`
  fragment EntitySearchItem on IEntity {
    ... on INode {
      id
    }

    name
    ...EntityAvatar
  }
  ${EntityAvatar.Fragment}
`;

export default Object.assign(EntitySearchItem, { Fragment: EntitySearchItemFragmentGQL });
